module.exports = __webpack_public_path__ + "static/content-833b9ca662d7e1dad47f15840288198f.svg";